// extracted by mini-css-extract-plugin
export default {"custom-mach-textarea-w":"GDueQ_custom-mach-textarea-w","custom-mach-textarea":"mog1A_custom-mach-textarea","custom-mach-textarea-disabled":"XaAMO_custom-mach-textarea-disabled"};